// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wr_a bik_b"};